import React from "react";
import { useDispatch } from "react-redux";
import logo from "../../assets/icon/asten-global-logo-client.png";
import { Link, useNavigate } from "react-router-dom";
import { CategoriesData } from "../../fakeData/CategoriesData";
import { searchAction } from "../../store/reducers/searchSlice";

function Categories() {
  let navigate = useNavigate();
  const dispatch = useDispatch();

  const handleClick = (value) => {
    navigate("/search?Category=" + value);
    dispatch(searchAction({ value: value, path: "Category" }));
  };

  return (
    <div className="bg-brand lg:py-16 py-10">
      <div className="mx-auto max-w-screen-2xl px-3 sm:px-10">

        {/* HEADER */}
        <div className="mb-10 flex justify-center">
          <div className="text-center w-full lg:w-2/5">
            <img
              alt="Ashten Global Logo"
              src={logo}
              className="mx-auto bg-white mb-2 rounded-md shadow-md"
              style={{ width: "30%", height: "60%" }}
            />
            <h2 className="text-xl lg:text-2xl text-white mb-2 font-semibold">
              Our Products
            </h2>
            <p className="text-base font-sans text-white leading-6">
              We provide following high quality products
            </p>
          </div>
        </div>

        {/* PERFECT GRID — NO GAPS BETWEEN CARDS */}
        <ul
          className="
            grid 
            grid-cols-1 
            sm:grid-cols-2 
            lg:grid-cols-2
            gap-5
          "
        >
          {CategoriesData.map((category, index) => (
            <li key={index} className="h-full">
              <div
                className="
                  bg-gradient-to-r from-green-200 via-indigo-100 to-green-100
                  rounded-lg 
                  shadow 
                  p-5 
                  h-full 
                  flex 
                  flex-col 
                  hover:shadow-lg 
                  transition-all 
                  border border-gray-200
                "
              >
                {/* TOP SECTION */}
                <div className="flex items-start">
                  <img
                    src={category.icon}
                    alt={category.name}
                    className="w-12 h-12 object-contain rounded-md"
                  />

                  <div className="pl-4">
                    <h3 className="text-sm font-semibold text-gray-800">
                      <Link
                        className="hover:text-emerald-500"
                        to={"/search?Category=" + category.path}
                      >
                        {category.name}
                      </Link>
                    </h3>
                  </div>
                </div>

                {/* SUBCATEGORIES — flex-grow FOR EQUAL HEIGHT */}
                <ul className="pt-3 mt-1 flex-grow">
                  {category.subCategories.map((sub, i) => (
                    <li key={i} className="pt-1">
                      <Link
                        onClick={() => handleClick(sub.path)}
                        className="flex items-center text-xs text-gray-600 hover:text-emerald-600"
                        to={"/search?Category=" + sub.path}
                      >
                        <svg
                          stroke="currentColor"
                          fill="currentColor"
                          strokeWidth="0"
                          viewBox="0 0 512 512"
                          height="1em"
                          width="1em"
                          className="mr-1"
                        >
                          <path
                            fill="none"
                            strokeLinecap="square"
                            strokeMiterlimit="10"
                            strokeWidth="48"
                            d="M184 112l144 144-144 144"
                          ></path>
                        </svg>
                        {sub.name}
                      </Link>
                    </li>
                  ))}
                </ul>

              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default Categories;
